export enum AuthType {
    BASIC = 'Basic',
    BEARER = 'Bearer',
}
